<template>
  <section id="home" class="big" v-html="home.text"></section>
</template>

<script>
import API from "@/api/service";
export default {
  data() {
    return {
      home: []
    };
  },
  watch: {
    $route() {
      API.home(this.$i18n.locale).then(page => {
        this.home = page.data.result;
      });
    }
  },
  created() {
    API.home(this.$i18n.locale).then(page => {
      this.home = page.data.result;
    });
  }
};
</script>

<style lang="scss" scoped>
#home {
  height: 100vh;
}
</style>
